import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: fixed;
  z-index: 2001;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(255, 255, 255, 0.8);
`;

const CenterContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  cursor: auto;
`;

type ModalWrapperProps = {
  onModalBackgroundClick?: () => void;
};

const ModalWrapper: React.SFC<ModalWrapperProps> = ({ children, onModalBackgroundClick }) => (
  <Container>
    <CenterContainer
      onClick={(e) => {
        if (e.currentTarget == e.target && onModalBackgroundClick) onModalBackgroundClick();
      }}
    >
      {children}
    </CenterContainer>
  </Container>
);

export default ModalWrapper;



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/ModalWindow.tsx